import React from 'react';
import cn from 'classnames';

import type { DsTextColor } from './typographyTextColor';
import { dsTextColorClassMap } from './typographyTextColor';

export interface DisplayProps {
  size?: 'default' | 's';
  weight?: 'light' | 'medium';
  color?: DsTextColor;
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
}

export const Display: React.FC<DisplayProps> = ({
  size = 'default',
  weight = 'light',
  color = 'primary',
  children,
  as: Component = 'div',
  className,
}) => {
  const classes = cn(
    {
      'text-ds-display': size === 'default',
      'text-ds-display-s': size === 's',
      'font-light': weight === 'light',
      'font-medium': weight === 'medium',
    },
    dsTextColorClassMap[color],
    className,
  );

  return <Component className={classes}>{children}</Component>;
};

export default Display;
